<div class="container d-flex flex-column px-3 py-3">
  <div class="product-search-wrapper p-2">
  <div class="row">
    <h6 class="mb-0 col-md-6" (click)="hideSearch = !hideSearch;$event.stopPropagation()">
      <img class="expand-icon px-2" [src]="hideSearch ? 'arrow_up.png' : 'arrow_down.png'">Search Product
       
    </h6>
    @if(!applyStyleAction && !hideSearch){
    <div class="form-check mb-2 col-md-6 d-flex justify-content-end align-items-center ">
      <input class="form-check-input mr-5 mb-1"(click)="$event.stopPropagation()" [(ngModel)]="deletedInd" type="checkbox">
      <label class="form-check-label"> Include Deleted Records</label>
    </div>
    }
  </div>
  @if(!hideSearch){
  <ng-container>
  <div class="col-md-12 g-0 row product-search-container p-0 mb-0 ml-5">
    <div class="col-md-12 g-0 mb-2 d-flex flex-column">
      <nz-select nzPlaceHolder="Lot #" nzSize="default" #lotSelect
        [nzShowSearch]="true" [nzAllowClear]="true" 
        [(ngModel)]="lotIdtext" (nzOnSearch)="onLotSearch($event)" (click)="$event.stopPropagation()"  (nzOpenChange)="onOpenChange($event)"
        style="height: 35px !important;width: 99% !important;" #SearchStyleText (keydown)="onlyAlphanumeric($event)">
        @for(lot of lotList; track lot){
        <nz-option [nzLabel]="lot.lotId" [nzValue]="lot.lotId"></nz-option>
        }
      </nz-select>
    </div>
    <div class="col-md-6 mb-2 d-flex flex-column">
      <nz-select nzPlaceHolder="Style Id" nzSize="default" [nzShowSearch]="true" [nzAllowClear]="true"
        [(ngModel)]="searchStyleIDText" (click)="$event.stopPropagation()" (ngModelChange)="getVersionList(searchStyleIDText)"
        style="height: 35px !important;width: 98% !important;" #SearchStyleText>
        @for(style of styleList; track style){
        <nz-option [nzLabel]="style" [nzValue]="style"></nz-option>
        }
      </nz-select>
    </div>
    <div class="col-md-6 mb-2 d-flex flex-column">
      <nz-input-group [nzSuffix]="clearVersion" style="height: 35px !important; width: 98%;">
        <input nz-input placeholder="Version" (click)="$event.stopPropagation()" [(ngModel)]="searchVersionText" [nzAutocomplete]="versionAuto" />
      </nz-input-group>
      <ng-template #clearVersion>
        @if (searchVersionText) {
        <span nz-icon nzType="close-circle" nzTheme="fill" style="cursor: pointer; color: #ccc;font-size: 12px;"
          (click)="clearVersionText()"></span>
        }
      </ng-template>
      <nz-autocomplete #versionAuto>
        @for (version of versionList; track version) {
        <nz-auto-option [nzLabel]="version.version" [nzValue]="version.version">
          {{ version.version }}
        </nz-auto-option>
        }
      </nz-autocomplete>
    </div>
  </div>
  <div class="col-md-12 g-0 row product-search-container p-0 mb-0 ml-5">
    <div class="col-md-6 mb-2 d-flex flex-column">
      <nz-select nzPlaceHolder="Brand" nzSize="default" [(ngModel)]="selectedBrand"
        (ngModelChange)="getGarmentList(selectedBrand)" (click)="$event.stopPropagation()" [nzAllowClear]="true" [nzShowSearch]="true"
        style="height: 35px !important;width: 98% !important;">
        @for(brand of brandList; track brand){
        <nz-option [nzLabel]="brand" [nzValue]="brand"></nz-option>
        }
      </nz-select>
    </div>
    <div class="col-md-6 mb-2 d-flex flex-column">
      <nz-select nzPlaceHolder="Garment" nzSize="default" [nzAllowClear]="true" [(ngModel)]="selectedGarment"
        (ngModelChange)="getSubGarmentList(selectedBrand,selectedGarment)" (click)="$event.stopPropagation()" style="height: 35px !important;width: 98% !important;">
        @for(garment of garmentList; track garment){
        <nz-option [nzLabel]="garment" [nzValue]="garment"></nz-option>
        }
      </nz-select>
    </div>
    <div class="col-md-6 d-flex flex-column">
      <nz-select nzPlaceHolder="Sub-garment" nzSize="default" (click)="$event.stopPropagation()" [nzAllowClear]="true" [(ngModel)]="selectedSubGarment"
        style="height: 35px !important;width: 98% !important;">
        @for(subGarment of subGarmentList; track subGarment){
        <nz-option [nzLabel]="subGarment" [nzValue]="subGarment"></nz-option>
        }
      </nz-select>
    </div>
    <div class="col-md-6 d-flex align-items-center justify-content-center ">
      <button nz-button nzType="primary" class="d-flex align-items-center justify-content-end mr-10" (click)="getSearchData();$event.stopPropagation()"
        [nzSize]="'default'">
        Search
      </button>
      <button (click)="resetSearch();$event.stopPropagation()" nz-button nzType="default" class="d-flex align-items-center" [nzSize]="'default'">
        Reset
      </button>
    </div>
    <div class="col-md-12" *ngIf="inValidProductSearch">
      <span class="text-danger">
        Select brand or enter text in search box!
      </span>
    </div>
  </div>
  </ng-container>
}
  </div>

  <div class="catalog-container my-2 d-flex row justify-content-center px-2 mb-0">
    @if(searchProductList.length > 0){
    <app-master-catalog-child-accordion [drawerView]="true" [catalogs]="searchProductList"
      (emitSeqId)="loadMasterCatalogProduct($event)" [applyStyleAction]="applyStyleAction"
      [resetListDetails]="resetListDetails"
      (emitAction)="handleCatalogAction($event)"></app-master-catalog-child-accordion>
    }
    @else{
    <div class="text-center p-4 no-records" *ngIf="!loadingData">
      <span class="mb-3 fs-12">No records found. Search products to load results!</span>
    </div>
    }
  </div>

  <div class="row d-flex justify-content-center px-2 mb-2" style="background-color: white;">
    <app-spinner *ngIf="loadingData"></app-spinner>
    <span class="text-center py-2" *ngIf="showLoadMore && !loadingData">Showing {{searchProductList?.length}} of
      {{metaFields?.total}} records</span>
    <button style="width: auto; margin-bottom: 20px;" *ngIf="showLoadMore && !loadingData" nz-button nzType="primary"
      class="d-flex align-items-center mr-10" (click)="getSearchData(true)" [nzSize]="'default'">
      Load More
    </button>
  </div>
</div>